export class Payinreq {
  fullName: string;
  email: string;
  documentId: string;
  amount: number;
}
